import { useRef } from 'react';

function canonicalPayload(value: any): any {
  if (Array.isArray(value)) return value.map(canonicalPayload);
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.keys(value).sort().map((key) => [key, canonicalPayload(value[key])])
    );
  }
  return value;
}

/** Keep one identity for an unchanged online submission, including a lost response. */
export function useOperationIdentity() {
  const pending = useRef<{ body: string; id: string } | null>(null);
  return {
    reset: () => { pending.current = null; },
    process: (data: any) => {
      const body = JSON.stringify(canonicalPayload(JSON.parse(JSON.stringify(data))));
      if (!pending.current || pending.current.body !== body) {
        pending.current = { body, id: crypto.randomUUID() };
      }
      return { ...data, operation_id: pending.current.id };
    }
  };
}
